import React, { useState, useEffect, useRef } from 'react';
import { HelpCircle } from 'lucide-react';

/**
 * Icono "?" con un popover de ayuda contextual. Click para abrir/cerrar.
 * Uso: <HelpTip>El color indica si el stock está por debajo del umbral.</HelpTip>
 */
export default function HelpTip({ children, className = '' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('click', onDoc);
    return () => document.removeEventListener('click', onDoc);
  }, [open]);

  return (
    <span ref={ref} className={'relative inline-flex ' + className}>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
        className="text-slate-400 hover:text-[hsl(var(--brand-light))]"
        aria-label="Más información"
      >
        <HelpCircle className="w-3.5 h-3.5" />
      </button>
      {open && (
        <span className="absolute left-5 top-0 z-20 w-64 bg-slate-900 text-white text-xs rounded-lg p-3 shadow-lg font-normal">
          {children}
        </span>
      )}
    </span>
  );
}
